$(document).ready(function(){
    $('.site-slider__testimonials').slick({
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            },
        ]
    });

    $('.site-slider__brands').slick({
        dots: true,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }
            },
        ]
    });

    $('.site-slider__shopbybrands').slick({
        dots: false,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    $('.site-slider__industry').slick({
        slidesToShow: 4, 
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite:false,

        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },

            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    
                }
            },
             {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                
                }
            },
        ]
    });

    $('.site-slider__middle').slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }
            },
        ]
    });

    $('.site-slider__best-selling').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    arrows: false,
                }
            },
            
            {
                breakpoint: 640,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
        ]
    });

    $('.site-slider__about-large').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.site-slider__about-small',
        adaptiveHeight: true,
    });

    $('.site-slider__about-small').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.site-slider__about-large',
        dots: false,
        arrows: false,
        focusOnSelect: true
    });

    $('.site-slider__about-large').slickLightbox({
        itemSelector: '> div > div > div > a'
    });

    $('.site-slider__blog-detail-large').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.site-slider__blog-detail-small',
        adaptiveHeight: true,
    });

    $('.site-slider__blog-detail-small').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.site-slider__blog-detail-large',
        dots: false,
        arrows: false,
        focusOnSelect: true
    });

    $('.site-slider__blog-detail-large').slickLightbox({
        itemSelector: '> div > div > div > a'
    });

    $('.site-slider__detail-large').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.site-slider__detail-small',
        adaptiveHeight: true,
    });

    $('.site-slider__detail-small').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.site-slider__detail-large',
        dots: false,
        arrows: false,
        focusOnSelect: true,
    });

    $('.site-slider__detail-large').slickLightbox({
        itemSelector: '> div > div > div > a'
    });

    $('.site-slider__detail').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
    $('.site-slider__examples').slick({
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.site-slider--hero').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        adaptiveHeight: true,

    });

    $('.site-slider--top-sellers').slick({
        slidesToShow: 4, 
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite:false,

        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },

            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    
                }
            },
             {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                
                }
            },
        ]
    });

    $('.site-slider--bestselling-bundles').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite:false,
 
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },

            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    
                }
            },
             {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                
                }
            },
        ]
    });



    $('.site-slider__seo-large').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
    });

    $('.site-slider__seo-large').slickLightbox({
        itemSelector: '> div > div > div > a'
    });


    $('.site-slider__seo-small')
        .on('init', function (event, slick) {
            $('.site-slider__seo-small .slick-slide.slick-current').addClass('is-active');
        })
        .slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            focusOnSelect: false,
            infinite: false,
        });

    $('.site-slider__seo-large').on('afterChange', function (event, slick, currentSlide) {
        $('.site-slider__seo-small').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.site-slider__seo-small .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.site-slider__seo-small .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('.site-slider__seo-small').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');
        $('.site-slider__seo-large').slick('slickGoTo', goToSingleSlide);
    });



    $('.site-slider__login-popup').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 1000,

    });
});